import { Typography } from '@/components/atoms';
import { ChevronRightIcon } from '@/components/atoms/icons';
import { useI18nContext, useUIColors } from '@/core/hooks';
import React from 'react';
import { Pressable, View } from 'react-native';

export interface ProfileRowProps {
    leading: React.ReactNode;
    title: string;
    subtitle?: string;
    onPress?: () => void;
}

export function ProfileRow({ leading, title, subtitle, onPress }: ProfileRowProps) {
    const colors = useUIColors();
    const { isRTL } = useI18nContext();

    return (
        <Pressable
            onPress={onPress}
            style={{
                backgroundColor: colors.backgroundLevel2,
                borderRadius: 12,
                padding: 16,
                flexDirection: 'row',
                alignItems: 'center',
                gap: 12,
            }}
        >
            <View style={{ width: 24, height: 24, alignItems: 'center', justifyContent: 'center' }}>{leading}</View>
            <View style={{ flex: 1, gap: 4 }}>
                <Typography variant="headline" color="primary">
                    {title}
                </Typography>
                {subtitle ? (
                    <Typography variant="caption" color="tertiary">
                        {subtitle}
                    </Typography>
                ) : null}
            </View>
            <View style={{ transform: [{ scaleX: isRTL ? -1 : 1 }] }}>
                <ChevronRightIcon color={colors.fontPrimary} size={24} />
            </View>
        </Pressable>
    );
}

export default ProfileRow;


